import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useStoreItems } from 'fulogics-ui-core/dist/layout/hooks/useStoreItems';
import { LoadOptions } from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { COSOrderForwardStepStore } from '../../store/models/COSOrderForwardStepModel';
import { COSOrderReturnStepStore } from '../../store/models/COSOrderReturnStepModel';

export const useMaxSendDate = (forwardStepId?: string, returnStepId?: string) => {
    const [maxSendDate, setMaxSendDate] = useState<Date | undefined>(undefined);

    const forwardStepOptions = useMemo(() => {
        if (forwardStepId) {
            return COSOrderForwardStepStore.createByCollectionId(forwardStepId) as LoadOptions;
        }

        return {};
    }, [forwardStepId]);

    const returnStepOptions = useMemo(() => {
        if (returnStepId) {
            return COSOrderReturnStepStore.createByCollectionId(returnStepId) as LoadOptions;
        }

        return {};
    }, [returnStepId]);

    const { data: forwardSteps, loading: loadingForwardSteps } = useStoreItems<{
        id?: string;
        plannedStartDate?: Date;
    }>(COSOrderForwardStepStore, forwardStepOptions, [forwardStepId]);

    const { data: returnSteps, loading: loadingReturnSteps } = useStoreItems<{
        id?: string;
        plannedStartDate?: Date;
    }>(COSOrderReturnStepStore, returnStepOptions, [returnStepId]);

    useEffect(() => {
        if (
            forwardSteps &&
            !loadingForwardSteps &&
            forwardStepId &&
            forwardSteps &&
            !loadingReturnSteps &&
            returnStepId
        ) {
            const stepsByDate = [...(forwardSteps || []), ...(returnSteps || [])]
                ?.filter((step: any) => !!step?.plannedStartDate)
                .sort(
                    (a: any, b: any) =>
                        new Date(a?.plannedStartDate).getTime() -
                        new Date(b?.plannedStartDate).getTime()
                );

            const maxDate = stepsByDate?.[0]?.plannedStartDate
                ? moment(stepsByDate?.[0]?.plannedStartDate).subtract(3, 'hours').toDate()
                : undefined;
            setMaxSendDate(maxDate);
        }
    }, [
        forwardSteps,
        loadingForwardSteps,
        forwardStepId,
        returnSteps,
        loadingReturnSteps,
        returnStepId,
    ]);

    const validationAdapter = useMemo(
        () => ({
            getValue: () => new Date(),
        }),
        [maxSendDate]
    );

    return {
        maxSendDate,
        loadingMaxSendDate: loadingForwardSteps || loadingReturnSteps,
        validationAdapter,
    };
};
